/**
 * @generated SignedSource<<ad848ef2c030384b9c0dbb654e369a1c>>
 * @relayHash 796dc965641af207a0b9419914846a68
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 20d04eb1eb34d95f608eed19bd7178ed5e44deabd2a8e0e10666e1f6ff5f998b

import type { ConcreteRequest, Query } from 'relay-runtime';
export type transitionsRelayQueryForStatusFieldQuery$variables = {
  cloudId: string;
  issueKey: string;
};
export type transitionsRelayQueryForStatusFieldQuery$data = {
  readonly jira: {
    readonly issueByKey: {
      readonly statusField: {
        readonly transitions: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly hasPreConditions: boolean | null | undefined;
              readonly hasScreen: boolean | null | undefined;
              readonly isGlobal: boolean | null | undefined;
              readonly isInitial: boolean | null | undefined;
              readonly isLooped: boolean | null | undefined;
              readonly name: string | null | undefined;
              readonly to: {
                readonly name: string | null | undefined;
                readonly statusCategory: {
                  readonly statusCategoryId: string;
                } | null | undefined;
                readonly statusId: string;
              } | null | undefined;
              readonly transitionId: number | null | undefined;
            } | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type transitionsRelayQueryForStatusFieldQuery = {
  response: transitionsRelayQueryForStatusFieldQuery$data;
  variables: transitionsRelayQueryForStatusFieldQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "issueKey"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "key",
    "variableName": "issueKey"
  }
],
v2 = [
  {
    "kind": "Literal",
    "name": "sortingOption",
    "value": "OPS_BAR_THEN_STATUS_CATEGORY"
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "transitionId"
},
v4 = {
  "kind": "ScalarField",
  "name": "name"
},
v5 = {
  "kind": "ScalarField",
  "name": "hasScreen"
},
v6 = {
  "kind": "ScalarField",
  "name": "isGlobal"
},
v7 = {
  "kind": "ScalarField",
  "name": "isInitial"
},
v8 = {
  "kind": "ScalarField",
  "name": "isLooped"
},
v9 = {
  "kind": "ScalarField",
  "name": "hasPreConditions"
},
v10 = {
  "kind": "ScalarField",
  "name": "statusId"
},
v11 = {
  "kind": "ScalarField",
  "name": "statusCategoryId"
},
v12 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "transitionsRelayQueryForStatusFieldQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraIssue",
            "kind": "LinkedField",
            "name": "issueByKey",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraStatusField",
                "kind": "LinkedField",
                "name": "statusField",
                "plural": false,
                "selections": [
                  {
                    "args": (v2/*: any*/),
                    "concreteType": "JiraTransitionConnection",
                    "kind": "LinkedField",
                    "name": "transitions",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "JiraTransitionEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "concreteType": "JiraTransition",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              (v4/*: any*/),
                              (v5/*: any*/),
                              (v6/*: any*/),
                              (v7/*: any*/),
                              (v8/*: any*/),
                              (v9/*: any*/),
                              {
                                "concreteType": "JiraStatus",
                                "kind": "LinkedField",
                                "name": "to",
                                "plural": false,
                                "selections": [
                                  (v10/*: any*/),
                                  (v4/*: any*/),
                                  {
                                    "concreteType": "JiraStatusCategory",
                                    "kind": "LinkedField",
                                    "name": "statusCategory",
                                    "plural": false,
                                    "selections": [
                                      (v11/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ],
                    "storageKey": "transitions(sortingOption:\"OPS_BAR_THEN_STATUS_CATEGORY\")"
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "transitionsRelayQueryForStatusFieldQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraIssue",
            "kind": "LinkedField",
            "name": "issueByKey",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraStatusField",
                "kind": "LinkedField",
                "name": "statusField",
                "plural": false,
                "selections": [
                  {
                    "args": (v2/*: any*/),
                    "concreteType": "JiraTransitionConnection",
                    "kind": "LinkedField",
                    "name": "transitions",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "JiraTransitionEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "concreteType": "JiraTransition",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              (v4/*: any*/),
                              (v5/*: any*/),
                              (v6/*: any*/),
                              (v7/*: any*/),
                              (v8/*: any*/),
                              (v9/*: any*/),
                              {
                                "concreteType": "JiraStatus",
                                "kind": "LinkedField",
                                "name": "to",
                                "plural": false,
                                "selections": [
                                  (v10/*: any*/),
                                  (v4/*: any*/),
                                  {
                                    "concreteType": "JiraStatusCategory",
                                    "kind": "LinkedField",
                                    "name": "statusCategory",
                                    "plural": false,
                                    "selections": [
                                      (v11/*: any*/),
                                      (v12/*: any*/)
                                    ]
                                  },
                                  (v12/*: any*/)
                                ]
                              },
                              (v12/*: any*/)
                            ]
                          }
                        ]
                      }
                    ],
                    "storageKey": "transitions(sortingOption:\"OPS_BAR_THEN_STATUS_CATEGORY\")"
                  },
                  (v12/*: any*/)
                ]
              },
              (v12/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "20d04eb1eb34d95f608eed19bd7178ed5e44deabd2a8e0e10666e1f6ff5f998b",
    "metadata": {},
    "name": "transitionsRelayQueryForStatusFieldQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "ef8a89687e1190fb71a38a47f8fc039c";

export default node;
